import React from 'react';

interface StatusBadgeProps {
  label: string;
  colour?: string;
  className?: string;
}

const COLOR_VARIANT_MAP: Record<string, string> = {
  success: '#2e7d32',
  ok: '#2e7d32',
  active: '#2e7d32',
  danger: '#d32f2f',
  off: '#d32f2f',
  expired: '#d32f2f',
  failed: '#d32f2f',
  warning: '#ed6c02',
  pending: '#ed6c02',
  info: '#0288d1',
  primary: '#1976d2',
  secondary: '#757575',
  inactive: '#757575',
  archived: '#757575',
  deleted: '#424242',
};

const resolveColor = (c?: string): string => {
  if (!c) return '#2e7d32';
  const lc = c.toLowerCase().trim();
  if (COLOR_VARIANT_MAP[lc]) return COLOR_VARIANT_MAP[lc];
  if (c.startsWith('#') || c.startsWith('rgb') || c.startsWith('hsl') || c.startsWith('var')) return c;
  return c;
};

const StatusBadge: React.FC<StatusBadgeProps> = ({ label, colour, className }) => {
  const dotColor = resolveColor(colour);

  return (
    <span
      className={`status-dot-label ${className || ''}`}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '8px',
        color: 'inherit',
        fontSize: '13px',
        fontWeight: 500,
        fontFamily: 'var(--font-sans)',
        whiteSpace: 'nowrap',
      }}
    >
      <span
        style={{
          width: '10px',
          height: '10px',
          borderRadius: '50%',
          backgroundColor: dotColor,
          flexShrink: 0,
        }}
      />
      {label}
    </span>
  );
};

export default StatusBadge;
